import {createAction, props} from '@ngrx/store';
import {EAccountConfirmationStatus, ELoginStatus} from '../models/auth-state.model';
import {IResetPasswordRequest} from '../models/reset-password.model';

export enum AuthActions {
  Authenticate = '[App Component] Authenticate - get token',
  AuthenticateSuccess = '[Auth Effects] Authenticate Success',
  AuthenticateFailure = '[Auth Effects] Authentication Failed',
  AuthenticateError = '[Auth Effects] Authentication Error',
  AccountConfirmationSuccess = '[Auth Effects] Account Confirmation Success',
  AccountConfirmationFailure = '[Auth Effects] Account Confirmation Failure',
  CheckAuth = '[Auth Effects] Check Auth',
  CheckAccountConfirmation = '[Account Confirmation Component] Check Account Confirmation',
  PreAuthForAccountConfirmation = '[App Component] PreAuth For Account Confirmation',
  preAuthForTermsAndCondition = '[TermsAndConditions Component] PreAuth for Terms and Conditions',
  preAuthForLegalNotice = '[LegalNotice Component] PreAuth for Legal Notice',
  preAuthForPrivacyPolicy = '[PrivacyPolicy Component] PreAuth for Privacy Policy',
  preAuthForCookiePolicy = '[CookiePolicy Component] PreAuth for Cookie Policy',
  preAuthForContact = '[Contact Component] PreAuth for Contact',
  PreAuthForLanguageLoader = '[LanguageLoader Class] PreAuth for LanguageLoader',
  ResetPassword = '[ResetPassword Component] Reset Password',
  ResetPasswordSuccess = '[Auth Effects] Reset Password Success',
  ResetPasswordFailure = '[Auth Effects] Reset Password Failed',
  ResetPasswordStateReset = '[ResetPassword Component] Reset Password State Reset',
  ForgotPassword = '[ResetPassword Component] forgot Password',
  ForgotPasswordSuccess = '[Auth Effects] forgot Password Success',
  ForgotPasswordFailure = '[Auth Effects] forgot Password Failed',
  ChangePassword = '[Profile Component] Change Password',
  ChangePasswordSuccess = '[Auth Effects] Change Password Success',
  ChangePasswordFailure = '[Auth Effects] Change Password Failed',
  ResetChangePasswordStatus = '[Auth Effects] Reset Change Password Status',
}
export const authenticate = createAction(AuthActions.Authenticate);
export const authenticateSuccess = createAction(
  AuthActions.AuthenticateSuccess,
  props<{token: string; status: ELoginStatus}>()
);
export const authenticateFailure = createAction(AuthActions.AuthenticateFailure);
export const authenticateError = createAction(AuthActions.AuthenticateError);
export const checkAuth = createAction(AuthActions.CheckAuth);
export const checkAccountConfirmation = createAction(
  AuthActions.CheckAccountConfirmation,
  props<{email: string; token: string}>()
);

export const accountConfirmationSuccess = createAction(
  AuthActions.AccountConfirmationSuccess,
  props<{accountConfirmationStatus: EAccountConfirmationStatus}>()
);

export const accountConfirmationFailure = createAction(
  AuthActions.AccountConfirmationFailure,
  props<{accountConfirmationStatus: EAccountConfirmationStatus}>()
);
export const preAuthForAccountConfirmation = createAction(AuthActions.PreAuthForAccountConfirmation);
export const preAuthForTermsAndCondition = createAction(AuthActions.preAuthForTermsAndCondition);
export const preAuthForLegalNotice = createAction(AuthActions.preAuthForLegalNotice);
export const preAuthForPrivacyPolicy = createAction(AuthActions.preAuthForPrivacyPolicy);
export const preAuthForCookiePolicy = createAction(AuthActions.preAuthForCookiePolicy);
export const preAuthForContact = createAction(AuthActions.preAuthForContact);
export const preAuthForLanguageLoader = createAction(AuthActions.PreAuthForLanguageLoader);

export const resetPassword = createAction(AuthActions.ResetPassword, props<{request: IResetPasswordRequest}>());
export const resetPasswordSuccess = createAction(
  AuthActions.ResetPasswordSuccess,
  props<{resetPasswordStatus: EAccountConfirmationStatus}>()
);
export const resetPasswordFailure = createAction(
  AuthActions.ResetPasswordFailure,
  props<{resetPasswordStatus: EAccountConfirmationStatus}>()
);

export const resetPasswordStateReset = createAction(AuthActions.ResetPasswordStateReset);

export const forgotPassword = createAction(AuthActions.ForgotPassword, props<{email: string}>());
export const forgotPasswordSuccess = createAction(
  AuthActions.ForgotPasswordSuccess,
  props<{forgotPasswordStatus: EAccountConfirmationStatus}>()
);
export const forgotPasswordFailure = createAction(
  AuthActions.ForgotPasswordFailure,
  props<{forgotPasswordStatus: EAccountConfirmationStatus}>()
);

export const changePassword = createAction(
  AuthActions.ChangePassword,
  props<{oldPassword: string; newPassword: string}>()
);
export const changePasswordSuccess = createAction(
  AuthActions.ChangePasswordSuccess,
  props<{changePasswordStatus: EAccountConfirmationStatus}>()
);
export const changePasswordFailure = createAction(
  AuthActions.ChangePasswordFailure,
  props<{
    changePasswordStatus: EAccountConfirmationStatus;
    errorMessage: string;
  }>()
);
export const resetChangePasswordStatus = createAction(AuthActions.ResetChangePasswordStatus);
